export default "__VITE_ASSET__CmF2erfW__"